import AttunementSlot from './AttunementSlot';

export default AttunementSlot;
export { AttunementSlot };
